import { render } from "./portal.vue?vue&type=template&id=653e8ec2&scoped=true&ts=true&lang=pug"
import script from "./portal.vue?vue&type=script&lang=ts"
export * from "./portal.vue?vue&type=script&lang=ts"

import "./portal.vue?vue&type=style&index=0&id=653e8ec2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653e8ec2"]])

export default __exports__